export default function GeneratorStep({ step, title, description, children, className = '' }) {
  return (
    <section className={`py-8 first:pt-0 last:pb-0 ${className}`}>
      <div className="mb-5 flex gap-3">
        <span
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-indigo-600 text-sm font-bold text-white"
          aria-hidden
        >
          {step}
        </span>
        <div>
          <h3 className="text-base font-semibold text-slate-900">{title}</h3>
          {description && (
            <p className="mt-0.5 text-sm text-slate-500">{description}</p>
          )}
        </div>
      </div>
      <div className="pl-11">{children}</div>
    </section>
  );
}
